import { useState } from "react"
import Sidebar from "./Sidebar"
import Header from "./Header"
import "../../styles/layout.scss"

type Props = {
  pageTitle: string
  children: React.ReactNode
  onBack?: () => void
}

const AppLayout = ({ pageTitle, children, onBack }: Props) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="app-layout">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div className="app-main">
        <Header
          pageTitle={pageTitle}
          onMenuOpen={() => setSidebarOpen(true)}
          onBack={onBack}
        />
        <main className="app-content">{children}</main>
      </div>
    </div>
  )
}

export default AppLayout
